import { baseNextjsUrl } from "@memorang/constants/src/urls";

const COPILOT_ENDPOINT = "/api/ai/copilot/openai";

export const COPILOT_URL = `${baseNextjsUrl}${COPILOT_ENDPOINT}`;

export const WARNING_MESSAGE =
	"This AI assistant is in **Beta**—responses may occasionally be inaccurate or incomplete.";
